import React, { useEffect } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import PaymentCycleManagementColumnModel from './payment-cycle-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'

const PaymentCycleManagementPage = (): any => {
  // useEffect(() => {
  //   document.title = "Payment Term Management";
  //   },[]);  
    useDocumentTitle();
  return (
    <CommonTablePage
      urlInfoKey={urlKey.PaymentCycle}
      title="Payment Term Management"
      column={PaymentCycleManagementColumnModel.PaymentCycleManagementColumn}
    />
  )
}

export default PaymentCycleManagementPage
